<script setup lang="ts">
const { baseUrl } = useRuntimeConfig().public
const { path } = useRoute()
useHead({
  titleTemplate: 'Jak wyglądają vouchery - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ],
  link: [
    { rel: 'canonical', href: `${baseUrl}${path}` }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Jak wyglądają vouchery' }]" />
    <div class="mt-[30px]">
      <Img src="/voucher-img/wizka_bner_top.jpg" alt="voucher na jazdę, prezent dla niego lub dla niej" width="1140" height="387" />
      <div class="mt-[30px]">
        <h1 class="text-24 md:text-32 font-bold">
          Jak wyglądają vouchery?
        </h1>
      </div>
      <p class="mt-[30px]">
        Gustowny i elegancki voucher ma format utwardzonej kartki a4, po złożeniu przyjmuje znany format DL. Dodatkiem do vouchera jest ekskluzywna koperta opatrzona grafiką go-racing z ozdobnym lakierowaniem. Tak przygotowany voucher jest idealnym i gotowym pomysłem na prezent z okazji świąt czy urodzin. Możesz też zrobić niespodziankę swojej bliskiej osobie i bez żadnych okazji podarować emocje w formie vouchera.
      </p>
    </div>

    <div class="flex flex-col justify-center md:block after:table after:content-[''] after:clear-both mt-[30px]">
      <Img
        src="/voucher-img/wizka-voucher-drukowan-375x344.jpg"
        alt="wnętrze vouchera go-racing"
        width="400"
        height="367"
        class="float-left md:mr-[20px] mb-[20px]"
      />
      <div class="mt-[10px]">
        <h3 class="text-16 font-medium">
          Tak wygląda przykładowy voucher prezentowy na jazdę Chevroletem Camaro
        </h3>
        <div>
          Każdy voucher zawiera:
          <ul class="list-['-_'] list-inside">
            <li>lokalizację, czyli miejsce realizacji vouchera,</li>
            <li>ilość okrążeń,</li>
            <li>numer - najważniejsza rzecz w całym voucherze, dzięki temu numerowi możesz zarezerwować i zrealizować jazdę,</li>
            <li>termin ważności, czyli wyznaczoną datę kiedy upływa ważność vouchera, każdy nasz voucher ma ważność 365 dni,</li>
            <li>krótki opis,</li>
            <li>szczegółowe informacje odnośnie wybranej jazdy, takie jak adres toru, obowiązujący strój, inne wymagania.</li>
          </ul>
        </div>
      </div>

      <div class="mt-[20px]">
        <h3 class="text-16 font-medium">
          Voucher elektroniczny
        </h3>
        <p class="mt-[10px]">
          Po dokonaniu zamówienia i jego opłaceniu otrzymujesz na adres email voucher elektroniczny w formacie PDF. Jest to najszybsza i darmowa forma dostawy. Jeżeli zależy Ci jednak na tym, aby voucher wyglądał bardziej wyjątkowo - zamów voucher tradycyjny z dostawą do paczkomatu lub kurierem.
        </p>
      </div>
    </div>

    <div class="flex flex-col justify-center md:block after:table after:content-[''] after:clear-both mt-[20px]">
      <Img
        src="/voucher-img/gr_opakowanie-417x278.jpg"
        alt="opakowanie ozdobne go-racing"
        width="442"
        height="295"
        class="float-right md:ml-[20px] mb-[20px]"
      />
      <div>
        <h2 class="text-20 font-medium md:text-right">
          Opakowanie ozdobne
        </h2>
        <p class="mt-[10px]">
          Jeśli chcesz, aby Twój prezent wyglądał jeszcze bardziej stylowo, wybierz podczas zakupu opcję "opakowanie ozdobne". Za dodatkową opłatą, zamówiony przez Ciebie voucher zostanie zapakowany w eleganckie, metalowe pudełko. Klasyczna, ponadczasowa czerń w połyskującym wydaniu, tłoczone logo i czerwone wnętrze nawiązują stylistyką do najbardziej kultowych klasyków motoryzacji i podkreślają sportowy charakter prezentu. Metalowe opakowanie ozdobne na vouchery Go-Racing zmieni zakupiony przez Ciebie voucher w gustowny i elegancko zapakowany prezent od razu gotowy do wręczenia.
        </p>
      </div>
    </div>

    <div class="flex flex-col justify-center md:block after:table after:content-[''] after:clear-both mt-[20px]">
      <Img
        src="/voucher-img/torebka_prezentowa-375x254.jpg"
        alt="torebka prezentowa go-racing"
        width="400"
        height="271"
        class="float-left md:mr-[20px] mb-[20px]"
      />
      <h2 class="text-20 font-medium">
        Torebka prezentowa
      </h2>
      <p class="mt-[10px]">
        Elegancka torebka ozdobna Go-Racing dopełni oprawę Twojego prezentu. Możesz połączyć ją z samym voucherem lub voucherem i opakowaniem ozdobnym - dla jeszcze lepszego efektu! Tłoczone logo i czarno-czerwona kolorystyka podkreślają sportowy charakter prezentu, zwiastując niezapomniane motoryzacyjne emocje.
      </p>
    </div>
  </div>
</template>
